import React, { useState, useEffect, useRef } from 'react';
// import GoogleMapComponent from './GoogleMapComponent';
import { fetchTourDetails, fetchSpecificTourDetail } from '../utils/api';
import { fetchPropertyDetails } from '../api-client';
import Loader from './LoaderComponent';
// import TripAdvisorRating from './TripAdvisor/TripAdvisorComponent';
// import HotelDetailThingsToDo from './HoteDetailThingsToDoComponent';
// import { processData } from '../data/processData';
// import { Country } from '../data/countryData';
import { PropertyDetails } from '../../../backend/src/models/getPropertyDetails';
import ReadMore from '../components/ReadMore';
import ReadMoreLines from '../components/ReadMoreLines';
import { useLocation } from 'react-router-dom';

// Define TypeScript interfaces for expected props and other objects
interface HotelDetailsProps {
  slug: string;
  roomDetails?: string;
  facilitiesTitle?: string;
  tourName?: string;
  mapTitle?: string;
  latitude: string;
  longitude: string;
  tourQuery: string;
  hotelId: string;
  destinationCode: string;
  hasWhyThisResort: boolean;
}

// interface Facility {
//   name: string;
//   icon: string;
// }

// interface RoomDetails {
//   facilities: Facility[];
//   photos: { url_max750: string }[];
// }

// interface HotelDetailsData {
//   data: {
//     name: string;
//     rooms: Record<string, RoomDetails>;
//     facilities_block: {
//       facilities: Facility[];
//     }
//   }
// }

interface TourProduct {
  id: string;
  title: string;
  productSlug: string;
}

interface TourDetailsData {
  data: {
    products: TourProduct[];
  }
}

const HotelDetailsComponent: React.FC<HotelDetailsProps> = ({
  //slug,
  roomDetails = "Room Details",
  // latitude,
  // longitude,
  tourQuery,
  hotelId,
  destinationCode,
  hasWhyThisResort
}) => {
  // const [hotelDetails, setHotelDetails] = useState<HotelDetailsData | null>(null);
  const [tourDetails, setTourDetails] = useState<TourDetailsData | null>(null);
  const [selectedTourDetail, setSelectedTourDetail] = useState<any>(null);
  const [error, setError] = useState<string>('');
  const [activeTab, setActiveTab] = useState<string>('overview');
  const [openTourSlug, setOpenTourSlug] = useState<string | null>(null);
  //const [currentPhotoIndex, setCurrentPhotoIndex] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // const [viewMore, setViewMore] = useState(false);
  const [viewMoreFacility, setViewMoreFacility] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState<PropertyDetails | null>(null);
  // const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  // const photosToShow = 3; // Number of photos to show at a time
  const hasFetchedDetails = useRef(false);
  const location = useLocation();

  const specificPages = ["/resort/hurawalhi-maldives"];
  const isSpecificPage = specificPages.includes(location.pathname);

  const marginClasses = hasWhyThisResort
    ? isSpecificPage
      ? "-mt-[1rem]" // If hasWhyThisResort and isSpecialPage
      : "-mt-[8.5rem]" // If hasWhyThisResort but not isSpecialPage
    : isSpecificPage
      ? "mt-[5rem]" // If not hasWhyThisResort but isSpecialPage
      : "-mt-[0rem]";

  const [openSections, setOpenSections] = useState<{ [key: string]: boolean }>({
    overview: true,
    // 'room-details': false,
    tours: false,
    facilities: false,
    map: false,
  });

  const toggleSection = (section: string) => {
    if (isMobile) {
      setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
    } else {
      setActiveTab(section);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set the initial value

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!hasFetchedDetails.current && destinationCode && hotelId) {
      hasFetchedDetails.current = true;
      getHotelDetails();
    }
  }, [destinationCode, hotelId]);

  useEffect(() => {
    loadTourDetails();
  }, [tourQuery]);

  const getHotelDetails = async () => {
    try {
      const data = await fetchPropertyDetails(destinationCode, hotelId);
      setPropertyDetails(data as PropertyDetails);
    } catch (error: any) {
      setError(error.message);
    }
  };

  const loadTourDetails = async () => {
    try {
      const data = await fetchTourDetails(tourQuery);
      setTourDetails(data as TourDetailsData);
    } catch (error: any) {
      setError(error.message);
    }
  };

  const handleFetchSpecificTourDetail = async (slug: string) => {
    if (slug === openTourSlug) {
      setSelectedTourDetail(null);
      setOpenTourSlug(null);
      return;
    }

    try {
      const data = await fetchSpecificTourDetail(slug);
      setSelectedTourDetail(data.data);
      setOpenTourSlug(slug);
    } catch (error: any) {
      setError(error.message);
    }
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!propertyDetails) {
    return <Loader />;
  }

  // const getCountryByTourQuery = (tourQuery: string): Country | undefined => {
  //   const processedData = processData();
  //   for (const continent of processedData) {
  //     const country = continent.countries.find((country: Country) => country.name.toLowerCase() === tourQuery.toLowerCase());
  //     if (country) {
  //       return country;
  //     }
  //   }
  //   return undefined;
  // };

  // const country = getCountryByTourQuery(tourQuery);

  const renderTabContent = (tabName: string) => {
    switch (tabName) {
      case 'overview':
        return (
          <div>
            <div id="Overview" className="grid grid-rows-1 gap-10 md:hidden lg:hidden lgx2:hidden px-2">
              <ReadMore mobileMaxCharacterCount={250}>
                <p className="text-sm text-gray-800">{roomDetails}</p><br />
                {/* {country && <HotelDetailThingsToDo country={country} />} */}
              </ReadMore>

            </div>
            <div id="Overview" className="grid grid-rows-1 gap-10 hidden md:block lg:block lgx2:block">
              <ReadMoreLines desktopMaxRows={3}>
                <p className="text-base text-gray-800">{roomDetails}</p><br />
                {/* {country && <HotelDetailThingsToDo country={country} />} */}
              </ReadMoreLines>
            </div>
          </div>
        );

      // case 'room-details':
      //   const roomDetailWithFacilities = hotelDetailsHB.rooms?.find(
      //     (room) => room.roomFacilities && room.roomFacilities.length > 0
      //   );
      //   const roomPhotos = hotelDetailsHB.images?.filter(
      //     (image) => image.type.description?.content === 'Room'
      //   );

      //   const nextPhotos = () => {
      //     setCurrentPhotoIndex(prevIndex => (prevIndex + photosToShow) % roomPhotos.length);
      //   };

      //   const prevPhotos = () => {
      //     setCurrentPhotoIndex(prevIndex => (prevIndex - photosToShow + roomPhotos.length) % roomPhotos.length);
      //   };

      //   // Check if a valid room with facilities exists
      //   if (
      //     !roomDetailWithFacilities ||
      //     !roomDetailWithFacilities.roomFacilities ||
      //     roomDetailWithFacilities.roomFacilities.length === 0
      //   ) {
      //     return (
      //       <div id="room-details" className="p-4 bg-white rounded-lg shadow-md">
      //         <p className="text-center text-gray-800 font-medium">
      //           Room details not found.
      //         </p>
      //       </div>
      //     );
      //   }

      //   const roomFacilities = roomDetailWithFacilities.roomFacilities;
      //   const roomFacilitiesToShow = viewMore ? roomFacilities : roomFacilities.slice(0, 9);

      //   return (
      //     <>
      //     <div id="room-details" className="p-4 bg-white rounded-lg shadow-md">
      //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      //         {roomFacilitiesToShow.map((facility, index) => (
      //           <div
      //             key={index}
      //             className="flex items-center bg-gray-50 rounded-lg p-2 shadow-sm hover:bg-gray-100 transition-colors"
      //           >
      //             <span className="text-gray-800 font-small">
      //               {facility.description?.content || 'No description available'}
      //             </span>
      //           </div>
      //         ))}
      //       </div>
      //       {roomFacilities.length > 9 && (
      //         <div className="flex justify-center mt-4">
      //           <button
      //             className="text-blue-500 hover:text-blue-700 transition-colors font-medium"
      //             onClick={() => setViewMore(!viewMore)}
      //           >
      //             {viewMore ? 'View Less' : 'View More'}
      //           </button>
      //         </div>
      //       )}


      //     <div className="mt-6">
      //       <div className="relative w-full h-[210px] overflow-hidden rounded-lg">
      //       <div className="flex w-full h-full">
      //           {[...Array(photosToShow)].map((_, i) => {
      //             const photoIndex = (currentPhotoIndex + i) % roomPhotos.length;
      //             const isMiddleImage = i === Math.floor(photosToShow / 2);

      //             return (
      //               <img
      //                 key={photoIndex}
      //                 src={`https://photos.hotelbeds.com/giata/${roomPhotos[photoIndex]?.path}`}
      //                 alt={`Room Photo ${photoIndex + 1}`}
      //                 className={`w-1/3 h-full object-cover ${isMiddleImage ? 'px-2' : ''}`} 
      //               />
      //             );
      //           })}
      //         </div>
      //         <button
      //           className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-700 transition-colors"
      //           onClick={prevPhotos}
      //         >
      //           &#8592;
      //         </button>
      //         <button
      //           className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-700 transition-colors"
      //           onClick={nextPhotos}
      //         >
      //           &#8594;
      //         </button>
      //       </div>
      //     </div>

      //     </div>
      //     </>
      //   );

      case 'things to do':
        return (
          <div id="tours">
            {tourDetails ? (
              <div className="scrollbar-initial bg-white shadow rounded-lg" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <ul className="divide-y divide-gray-200">
                  {tourDetails.data.products.slice(0, 5).map((product) => (
                    <li key={product.id} className="py-4 px-4 hover:bg-gray-100 transition-colors">
                      <button
                        onClick={() => handleFetchSpecificTourDetail(product.productSlug)}
                        className="text-left w-full text-gray-800 flex justify-between items-center"
                      >
                        <span className="font-medium">{product.title}</span>
                        <span className="text-md" style={{ color: openTourSlug === product.productSlug ? '#dc0069' : '#000000' }}>
                          {openTourSlug === product.productSlug ? '⮝' : '⮟'}
                        </span>
                      </button>
                      {selectedTourDetail && openTourSlug === product.productSlug && (
                        <div className="mt-3 bg-gray-50 rounded-lg p-4 shadow-md">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <img className="rounded-lg object-cover" src={selectedTourDetail.photos[0]?.medium} alt={selectedTourDetail.name} />
                            <img className="rounded-lg object-cover" src={selectedTourDetail.photos[1]?.medium} alt={selectedTourDetail.name} />
                            <img className="rounded-lg object-cover" src={selectedTourDetail.photos[2]?.medium} alt={selectedTourDetail.name} />
                          </div>
                          <p className="mt-4 text-gray-700">{selectedTourDetail.description}</p>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <Loader />
            )}
          </div>
        );
      case 'facilities':
        const facilities = propertyDetails.facilities;
        const facilitiesToShow = viewMoreFacility ? facilities : facilities.slice(0, 9);
        return (
          <div id="facilities" className="p-2 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {facilitiesToShow!.map((facility, index) => (
                <div key={index} className="flex items-center p-2 bg-gray-50 rounded-lg shadow-sm hover:bg-gray-100 transition-colors">
                  {/* <img src={`/facilitiesIcons/${facility.icon}.svg`} alt={facility.name} className="h-6 w-6 text-gray-600" /> */}
                  <span className="ml-3 text-gray-800 font-small text-[13px]">{facility.name}</span>
                </div>
              ))}
            </div>
            {facilities!.length > 9 && (
              <div className="flex justify-center mt-4">
                <button
                  className="text-blue-500 hover:text-blue-700 transition-colors font-medium"
                  onClick={() => setViewMoreFacility(!viewMoreFacility)}
                >
                  {viewMoreFacility ? 'View Less' : 'View More'}
                </button>
              </div>
            )}
          </div>
        );
      // case 'map':
      //   return (
      //     <div>
      //       <div className="map-container" style={{ height: '500px', width: '100%' }}>
      //         <GoogleMapComponent
      //           apiKey="AIzaSyD3BQK4fqJwhNVoFZyk6EB1whUD-3NehqI"
      //           latitude={parseFloat(latitude)}
      //           longitude={parseFloat(longitude)}
      //           zoom={17}
      //         />
      //       </div>
      //     </div>
      //   );
      default:
        return null;
    }
  };

  return (
    <>
      <div className={`md:flex md:gap-x-36 md:w-[800px] 2xl:w-[1000px] hidden md:block ${marginClasses}`}>
        <div className="container py-6 px-4 md:px-1 2xl:flex-[4_4_0%] md:flex-[3_3_0%]">
          <div className="flex flex-col md:flex-row md:space-x-5 mb-4">
            {['overview', 'things to do', 'facilities'].map((tabName) => (
              <div key={tabName} className="mb-2 md:mb-0">
                <button
                  className={`w-full text-left text-[22px] font-semibold ${activeTab === tabName ? 'md:border-b-2 md:border-halo-pink' : ''}`}
                  onClick={() => toggleSection(tabName)}
                >
                  {tabName.charAt(0).toUpperCase() + tabName.slice(1).replace(/-/g, ' ')}
                  <span className="float-right md:hidden text-md">
                    {openSections[tabName] ? '−' : '+'}
                  </span>
                </button>
                {isMobile && openSections[tabName] && (
                  <div className="pt-4 pb-2 border-t border-b border-gray-200">
                    {renderTabContent(tabName)}
                  </div>
                )}
              </div>
            ))}
          </div>
          {!isMobile && renderTabContent(activeTab)}
        </div>
      </div>
      <div className='md:flex md:gap-x-36 md:w-[800px] 2xl:w-[1000px] md:-mt-52 md:hidden'>
        <div className="container py-6 px-4 md:px-1 2xl:flex-[4_4_0%] md:flex-[3_3_0%]">
          <div className="flex flex-col md:flex-row md:space-x-5 mb-4">
            {['overview', 'things to do', 'facilities'].map((tabName) => (
              <div key={tabName} className="mb-2 md:mb-0">
                <button
                  className={`w-full text-left text-[20px] font-medium flex justify-between items-center p-3 md:p-4 border border-gray-300 rounded-lg shadow-sm transition-all duration-300 ${activeTab === tabName
                    ? 'bg-white text-black hover:bg-halo-pink-bg hover:text-halo-pink'
                    : 'bg-white text-black hover:bg-halo-pink-bg hover:text-halo-pink'
                    }`}
                  onClick={() => toggleSection(tabName)}
                >
                  {tabName.charAt(0).toUpperCase() + tabName.slice(1).replace(/-/g, ' ')}
                  <span className="text-lg font-semibold">
                    {openSections[tabName] ? '−' : '⌵'}
                  </span>
                </button>
                {isMobile && openSections[tabName] && (
                  <div className="pt-4 pb-2 border-t border-b border-gray-200 transition-all duration-300">
                    {renderTabContent(tabName)}
                  </div>
                )}
              </div>
            ))}
          </div>
          {!isMobile && renderTabContent(activeTab)}
        </div>
      </div>
    </>
  );
};

export default HotelDetailsComponent;
